import React, { useState, useEffect } from "react";
import {
  Table,
  Empty,
  Drawer,
  Col,
  Row,
  notification,
  Popconfirm,
  Modal,
  Button,
} from "antd";
import {
  PlusOutlined,
  BarsOutlined,
  EditOutlined,
  DeleteOutlined,
  KeyOutlined,
  FieldTimeOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import UserAddForm from "../Forms/UserAddForm";
import UserUpdate from "../Forms/UserUpdateForm";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import RequestHandler from "../../util/RequestHandler";

const openNotificationWithIconDelete = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Silme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};
const openNotificationWithIconWarningDelete = (type) => {
  notification[type]({
    message: "HATA",
    description: "Silme işlemi sırasında bir hata oluştu.",
    duration: 2,
  });
};

const UserList = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-device-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });
  const [currentPage, setCurrentPage] = useState(1);
  const [user, setUser] = useState({ data: [], total: 0, loading: true });
  const [dataState, setDataState] = useState([{ skip: 0, take: 15 }]);
  const [visible, setVisible] = useState(false);
  const [firstName, setFirstName] = useState(10);
  const [lastName, setLastName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isTosAuthorize, setIsTosAuthorize] = useState();
  const [tosAuthorizeLimit, setTosAuthorizeLimit] = useState();
  const [tosAuthorizeId, setTosAuthorizeId] = useState();
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [wrongLoginList, setWrongLoginList] = useState([]);
  const [erpSalesCode, seterpSalesCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [take, setTake] = useState(15);
  const [skip, setSkip] = useState(0);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const history = useHistory();
  const [isHaveAccessDeleteStock, setIsHaveAccessDeleteStock] = useState(false);

  useEffect(() => {
    getUsers();
  }, [setDataState, take, setTake, skip, setSkip]);

  const getUsers = () => {
    setUser({
      ...user,
      loading: true,
    });

    RequestHandler.get(`/TenantUser?$count=true&$skip=${skip}&$top=${take}`).then(response => {
      setUser({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'Başarılı',
      description:
        'İşlem başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDelete = (key) => {
    RequestHandler.delete(`/User/DeleteTenantUser/${key}`).then((res) => {
      if (res.success) {
        getUsers();
      }
    });
  };

  const showWrongLogin = (value) => {
    RequestHandler.get(`/User/lastWrongLogin/${value}`).then((response) => {
      const list = [];
      response.map((item) => {
        list.push(item.addDate);
      })
      setWrongLoginList(list);
      showModal();
    });
  }

  const paging = (p) => {
    setDataState((prevState) => {
      prevState.skip = (p.current - 1) * p.pageSize;
      setSkip(prevState.skip);
      setTake(p.pageSize);
      setCurrentPage(p.current);
      return {
        prevState,
      };
    });
  };

  const showDrawerUpdate = (value, isTosAuthorize, tosAuthorizeId, tosAuthorizeLimit, isHaveAccessDeleteStock) => {
    RequestHandler.get(`/User/getbyid/${value}`).then((response) => {
      setFirstName(response.firstName);
      setLastName(response.lastName);
      setEmail(response.email);
      setPhoneNumber(response.phoneNumber);
      setUserId(response.id);
      setIsTosAuthorize(isTosAuthorize);
      setTosAuthorizeId(tosAuthorizeId);
      setTosAuthorizeLimit(tosAuthorizeLimit);
      setIsHaveAccessDeleteStock(isHaveAccessDeleteStock);
      setVisibleUpdate(true);
    });

    RequestHandler.get(`/User/GetSalesCode/${value}`).then((response) => {
      seterpSalesCode(response);
    });
  };

  const goTenantIdPage = (value) => {
    history.push(`user-roles/${value}`);
  };

  const goAccountAccessPage = (value) => {
    history.push(`user-accounts-roles/${value}`);
  };

  const goEntityPermissionPage = (tenantUserId) => {
    history.push(`entity-permission/${tenantUserId}`);
  };

  const dataStateChange = (e) => {
    setUser(e);
  };

  const setTosAuthorize = (tenantUserId) => {
    RequestHandler.post(`/TosAuthorize`, { tenantUserId: tenantUserId }, false, { rawResponse: true }).then(res => {
      if (res.status == 200) {
        openNotificationWithIcon('success');
        reList();
      }
    });
  };

  const onClose = () => {
    setVisibleUpdate(false);
    setVisible(false);
  };
  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };
  const reList = () => {
    setUser({
      ...user,
      loading: true,
    });

    RequestHandler.get(`/TenantUser?$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setUser({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getData = (val) => {
    if (val === "success") {
      reList();
      setVisibleUpdate(false);
      setVisible(false);
    }
  };

  const columns = [
    {
      title: "Ad",
      dataIndex: "firstName",
      align: "center",
    },
    {
      title: "Soyad",
      dataIndex: "lastName",
      align: "center",
    },
    {
      title: "E-posta Adresi",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Son 5 Hatalı Giriş",
      dataIndex: "wrongLogin",
      align: 'center',
      key: "wrongLogin",
      render: (text, record) =>
        user.data.length >= 1 ? (
          <a
            onClick={() => {
              showWrongLogin(record.userId);
            }}
            style={{ color: "red", fontSize: "130%" }}
          >
            <WarningOutlined />
          </a>
        ) : null,
    },
    {
      title: "Ekran Yetkilendirme",
      dataIndex: "id",
      align: "center",
      render: (text, record) =>
        user.data.length >= 1 ? (
          <a
            onClick={() => {
              goTenantIdPage(record.userId);
            }}
            style={{ color: "black", fontSize: "130%" }}
          >
            <KeyOutlined />
          </a>
        ) : null,
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (text, record) =>
        user.data.length >= 1 ? (
          <a
            onClick={() => {
              showDrawerUpdate(record.userId, record.isTosAuthorize, record.tosAuthorizeId, record.tosAuthorizeLimit,record.isHaveAccessDeleteStock);
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ) : null,
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (text, record) =>
        user.data.length >= 1 ? (
          record.isAdmin !== true ? (
            <Popconfirm
              title="Silmek istiyor musunuz?"
              okText="Evet"
              cancelText="Hayır"
              onConfirm={() => handleDelete(record.id)}
            >
              <a style={{ color: "red", fontSize: "130%" }}>
                <DeleteOutlined />
              </a>
            </Popconfirm>
          ) : null
        ) : null,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -9 }}>
            <BarsOutlined /> KULLANICI LİSTESİ
          </p>
        </Col>
        <Col xs={8} style={{ marginTop: -9, textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setVisible(true);
            }}
          >
            <PlusOutlined /> Kullanıcı Ekle
          </Button>
        </Col>
      </Row>
      <Drawer
        title="Kullanıcı Güncelle"
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
        destroyOnClose={true}
      >
        <UserUpdate
          firstName={firstName}
          lastName={lastName}
          erpSalesCode={erpSalesCode}
          phoneNumber={phoneNumber}
          email={email}
          isTosAuthorize={isTosAuthorize}
          tosAuthorizeId={tosAuthorizeId}
          tosAuthorizeLimit={tosAuthorizeLimit}
          sendDataForUpdate={getData}
          userId={userId}
          // isHaveAccessDeleteStock={isHaveAccessDeleteStock}
        />
      </Drawer>
      <Drawer
        title="Kullanıcı Ekle"
        width={241}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
        destroyOnClose={true}
      >
        <UserAddForm />
      </Drawer>
      <Row>
        {isDesktopOrLaptop && (
          <>
            <Col span={2}></Col>
            <Col span={20}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                size="small"
                rowKey="id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                onDataStateChange={dataStateChange}
                pagination={{
                  pageSizeOptions: ["15", "25", "50", "100"],
                  defaultPageSize: take,
                  total: user.total,
                  current: currentPage,
                }}
                dataSource={user.data}
                loading={user.loading}
              />
            </Col>
            <Col span={2}></Col>
          </>
        )}
        {isTabletOrMobileDevice && (
          <>
            <Col span={24}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", width: "100%", maxHeight: "100%" }}
                size="small"
                rowKey="id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{ pageSize: 20, total: user.total }}
                dataSource={user.data}
                loading={user.loading}
              />
            </Col>
          </>
        )}
      </Row>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        title={<div style={{ textAlign: 'center' }}>Son 5 Hatalı Giriş</div>}
        width={300}
        cancelButtonProps={{ hidden: true }}
        footer={null}
        okButtonProps={{ hidden: true }}
        onCancel={handleCancel}>
        <div>
          {wrongLoginList.length > 0 ?
            wrongLoginList.map((item) => {
              return <p style={{ textAlign: 'center' }} ><FieldTimeOutlined style={{ color: 'darkred' }} /> {moment(item).format('L LTS')}</p>
            }) : <p style={{ textAlign: 'center' }}>Hatalı Giriş Bulunmamaktadır.</p>}
        </div>
      </Modal>
    </>
  );
};

export default UserList;
